import * as capitalRenewalStatusActions from '../actions/capital-renewal-status.actions';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { InsuranceStatus } from "../../components/models/insurance-status.model";
import { CapitalRenewalStatus } from "../../components/models/capital-renewal-status.model";

export interface CapitalRenewalStatusState {
    insuranceStatus: any;
    capitalRenewalStatus: any;
    loading: boolean;
    loaded: boolean;
    updateInsuranceStatusSuccess: boolean;
    addInsuranceStatusSuccess: boolean;
    error: any;
}

const initialState = {
    insuranceStatus: null,
    capitalRenewalStatus: null,
    loading: false,
    loaded: false,
    updateInsuranceStatusSuccess: null,
    addInsuranceStatusSuccess: null,
    error: null
};

export const capitalRenewalStatusReducer = (state = initialState, action) => {
    switch (action.type) {
        case capitalRenewalStatusActions.GET_INSURANCE_STATUS:
            return {
                ...state,
                error: null,
                loading: true,
                loaded: state.loaded,
                updateInsuranceStatusSuccess: null,
                addInsuranceStatusSuccess: null
            };
        case capitalRenewalStatusActions.GET_INSURANCE_STATUS_SUCCESS:
            const insuranceStatus = new InsuranceStatus(action.payload);
            return {
                ...state,
                insuranceStatus: insuranceStatus,
                error: null,
                loading: false,
                loaded: true,
            };
        case capitalRenewalStatusActions.GET_INSURANCE_STATUS_FAIL:
            return {
                ...state,
                error: action.payload,
                loading: false,
                loaded: false
            };
        case capitalRenewalStatusActions.UPDATE_INSURANCE_STATUS_SUCCESS:
            return {
                ...state,
                error: null,
                insuranceStatus: state.insuranceStatus,
                updateInsuranceStatusSuccess: true
            };

        case capitalRenewalStatusActions.UPDATE_INSURANCE_STATUS_FAIL:
            return {
                ...state,
                error: action.payload,
                updateInsuranceStatusSuccess: false,
            };

        case capitalRenewalStatusActions.ADD_INSURANCE_STATUS_SUCCESS:
            return {
                ...state,
                error: null,
                insuranceStatus: state.insuranceStatus,
                addInsuranceStatusSuccess: true
            };

        case capitalRenewalStatusActions.ADD_INSURANCE_STATUS_FAIL:
            return {
                ...state,
                error: action.payload,
                addInsuranceStatusSuccess: false,
            };

        case capitalRenewalStatusActions.RESET_INSURANCE_STATUS_CRUD:
            return {
                ...state,
                error: null,
                updateInsuranceStatusSuccess: null,
                loading: null,
                loaded: null,
            };
        case capitalRenewalStatusActions.CLEAR_INSURANCE_STATUS:
            return {
                ...state,
                error: null,
                insuranceStatus: null,
                loading: false,
                loaded: false
            };
        case capitalRenewalStatusActions.GET_CAPITAL_RENEWAL_STATUS:
            return {
                ...state,
                error: null,
                loading: true,
                loaded: state.loaded
            };
        case capitalRenewalStatusActions.GET_CAPITAL_RENEWAL_STATUS_SUCCESS:
            const crStatus = new CapitalRenewalStatus(action.payload);
            return {
                ...state,
                capitalRenewalStatus: crStatus,
                error: null,
                loading: false,
                loaded: true,
            };
        case capitalRenewalStatusActions.GET_CAPITAL_RENEWAL_STATUS_FAIL:
            return {
                ...state,
                error: action.payload,
                loading: false,
                loaded: false
            };
        default:
            return state;
    }
};

// export const getCapitalRenewalStatusState = createFeatureSelector<CapitalRenewalStatusState>('capitalRenewalStatusReducer');
export const getInsuranceStatus = (state: CapitalRenewalStatusState) => state.insuranceStatus;
export const getCapitalRenewalStatusUpdateStatus = (state: CapitalRenewalStatusState) => state.updateInsuranceStatusSuccess;
export const getCapitalRenewalStatusAddStatus = (state: CapitalRenewalStatusState) => state.addInsuranceStatusSuccess;
export const getCapitalRenewalStatusLoaded = (state: CapitalRenewalStatusState) => state.loaded;
export const getCapitalRenewalStatus = (state: CapitalRenewalStatusState) => state.capitalRenewalStatus;
